module.exports = __webpack_public_path__ + "img/master_dokumen.e3b3011d.png";